import React, { useState, useEffect } from 'react';
import { Modal, Button, TextField, Grid, Box, FormControlLabel, Checkbox, Select, MenuItem, InputLabel, FormControl } from '@mui/material';

function ParametroModal({ open, handleClose, handleSave, usuarioActual }) {
  const server = process.env.REACT_APP_API_ROUTE;
  const key = process.env.REACT_APP_API_KEY;
  const [analito, setAnalito] = useState('');
  const [ingresadoPor, setIngresadoPor] = useState(usuarioActual || ''); // Prellenar si se pasa el valor
  const [cuantitativo, setCuantitativo] = useState(false);
  const [mostrarEnlinea, setMostrarEnlinea] = useState(false);
  const [modulo, setModulo] = useState('');
  const [modulos, setModulos] = useState([]); // Para almacenar los datos de los módulos
  const [error, setError] = useState(''); // Para mostrar errores

  useEffect(() => {
    const fetchModulos = async () => {
      try {
        const response = await fetch(`${server}/MgModuloes/porIdTipo/1`);
        const data = await response.json();
        setModulos(data.$values || []); // Asegurarse de que siempre sea un array
      } catch (error) {
        console.error('Error al cargar los módulos:', error);
        setError('Error al cargar los módulos.');
      }
    };

    fetchModulos();
  }, []);

  const handleGuardar = async () => {
    if (!analito || !modulo) {
      setError('Todos los campos son obligatorios.');
      return;
    }

    // Datos a enviar a la API
    const nuevoParametro = {
      analito,
      ingresadoPor,
      cuantitativo,
      mostrarEnlinea,
      idModulo: modulo,
    };

    try {
      // Llamada POST a la API
      const response = await fetch(`${server}/MgAnalitoes`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(nuevoParametro),
      });

      if (response.ok) {
        // Si la petición fue exitosa
        const data = await response.json();
        console.log('Parámetro guardado:', data);

        // Notificar al componente padre
        handleSave(data);

        // Limpiar campos después de guardar
        setAnalito('');
        setIngresadoPor(usuarioActual || '');
        setCuantitativo(false);
        setMostrarEnlinea(false);
        setModulo('');

        // Cerrar modal
        handleClose();
      } else {
        // Si hubo un error en la petición
        const errorData = await response.json();
        setError(`Error al guardar el parámetro: ${errorData.message}`);
      }
    } catch (error) {
      console.error('Error al guardar el parámetro:', error);
      setError('Ocurrió un error al guardar el parámetro.');
    }
  };

  return (
    <Modal open={open} onClose={handleClose}>
      <Box
        sx={{
          padding: '20px',
          backgroundColor: 'white',
          margin: '50px auto',
          maxWidth: '500px',
          borderRadius: '8px',
          boxShadow: 24,
        }}
      >
        <h2>Agregar Parámetro</h2>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Analito"
              value={analito}
              onChange={(e) => {
                setAnalito(e.target.value);
                setError(''); // Limpiar el mensaje de error si el usuario empieza a escribir
              }}
              error={!!error && !analito}
              helperText={!!error && !analito ? 'El campo analito es obligatorio.' : ''}
            />
          </Grid>
          <Grid item xs={12}>
            <FormControl fullWidth>
              <InputLabel>Módulo</InputLabel>
              <Select
                value={modulo}
                onChange={(e) => setModulo(e.target.value)}
                error={!!error && !modulo}
              >
                {modulos.map((mod) => (
                  <MenuItem key={mod.idModulo} value={mod.idModulo}>
                    {mod.nombreModulo}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={cuantitativo}
                  onChange={(e) => setCuantitativo(e.target.checked)}
                />
              }
              label="Cuantitativo"
            />
          </Grid>
          <Grid item xs={12}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={mostrarEnlinea}
                  onChange={(e) => setMostrarEnlinea(e.target.checked)}
                />
              }
              label="Mostrar en Línea"
            />
          </Grid>
          <Grid item xs={12} style={{ textAlign: 'right' }}>
            <Button onClick={handleGuardar} variant="contained" color="primary">
              Guardar
            </Button>
            <Button
              onClick={handleClose}
              variant="outlined"
              color="secondary"
              style={{ marginLeft: '10px' }}
            >
              Cancelar
            </Button>
          </Grid>
        </Grid>
      </Box>
    </Modal>
  );
}

export default ParametroModal;
